import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';
import PrecisionService from '@services/PrecisionService';

export function mapToCancellationAmendmentDetails(data: any): IListingData {
  const covers =
    data?.Production?.queries?.getCancellationAmendmentDetails || [];

  const pagedItems: IAbstractRecord = {};

  covers.forEach((cover: any, index: number) => {
    const baseExcessOnClaimType =
      cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
        ?.properties?.ExcessOnClaimType;
    const amendmentExcessOnClaimType =
      cover?.amendmentPPCVariance_AmendmentExcessOnClaimType;

    const currencySymbol =
      cover?.amendmentPOVariance_PricingOptionCurrency?.Symbol ?? '';

    let baseExcessValue: string | null = null;
    if (baseExcessOnClaimType === 'AMOUNT') {
      const amount =
        cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
          ?.properties?.ExcessOnClaimAmount ?? '';
      baseExcessValue = `${currencySymbol}${amount}`;
    } else if (baseExcessOnClaimType === 'PERCENTAGE') {
      const percentage = PrecisionService.multiplyBy100(
        cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
          ?.properties?.ExcessOnClaimPercentage || 0
      );
      baseExcessValue = `${percentage} %`;
    } else if (baseExcessOnClaimType === 'DAYS') {
      const days =
        cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
          ?.properties?.ExcessOnClaimDays ?? '';
      baseExcessValue = `${days} Days`;
    }

    let amendmentExcessValue: string | null = null;
    if (amendmentExcessOnClaimType === 'AMOUNT') {
      const amount =
        cover?.amendmentPPCVariance_AmendmentExcessOnClaimAmount ?? '';
      amendmentExcessValue = `${currencySymbol}${amount}`;
    } else if (amendmentExcessOnClaimType === 'PERCENTAGE') {
      const percentage = PrecisionService.multiplyBy100(
        cover?.amendmentPPCVariance_AmendmentExcessOnClaimPercentage || 0
      );
      amendmentExcessValue = `${percentage} %`;
    } else if (amendmentExcessOnClaimType === 'DAYS') {
      const days = cover?.amendmentPPCVariance_AmendmentExcessOnClaimDays ?? '';
      amendmentExcessValue = `${days} Days`;
    }

    pagedItems[index] = {
      id: cover?.amendmentPPCVariance_Id,
      PolicyCover: `${
        cover?.amendmentPPCVariance_PolicyCoverID?.views
          ?.PlanConfigManagement_all?.properties?.ExternalCode || ''
      } - ${
        cover?.amendmentPPCVariance_PolicyCoverID?.views
          ?.PlanConfigManagement_all?.properties?.Name || ''
      }`,
      IsMandatory: cover?.amendmentPPCVariance_PolicyPlanCoverID?.views
        ?.Production_all?.properties?.IsMandatory
        ? 'Yes'
        : 'No',
      IsEditable:
        cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
          ?.properties?.IsEditable,
      SumInsuredIsAdditive: cover?.amendmentPPCVariance_PolicyPlanCoverID?.views
        ?.Production_all?.properties?.SumInsuredIsAdditive
        ? 'Yes'
        : 'No',
      CoverSumInsured:
        cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
          ?.properties?.CoverSumInsured,
      CoverPremiumValue:
        cover?.amendmentPPCVariance_PolicyPlanCoverID?.views?.Production_all
          ?.properties?.CoverPremiumValue,
      Excess: baseExcessValue,
      ExcessOnClaimType: baseExcessOnClaimType,
      ExcessVariance: amendmentExcessValue,
      AmendmentExcessOnClaimType: amendmentExcessOnClaimType,
      EffectiveFrom: cover?.amendmentPPCVariance_AmendmentCoverEffectiveFrom,
      EffectiveTo: cover?.amendmentPPCVariance_AmendmentCoverEffectiveTo,
      AmendmentCoverSumInsured:
        cover?.amendmentPPCVariance_AmendmentCoverSumInsured,
      AmendmentCoverPremiumValue:
        cover?.amendmentPPCVariance_AmendmentCoverPremiumValue,
      AmendmentCoverPremiumPercentage:
        cover?.amendmentPPCVariance_AmendmentCoverPremiumPercentage,
      AmendmentExcessOnClaimPercentage:
        cover?.amendmentPPCVariance_AmendmentExcessOnClaimPercentage,
      AmendmentExcessOnClaimAmount:
        cover?.amendmentPPCVariance_AmendmentExcessOnClaimAmount,
      AmendmentExcessOnClaimDays:
        cover?.amendmentPPCVariance_AmendmentExcessOnClaimDays,
      AmendmentCoverPremiumType:
        cover?.amendmentPPCVariance_AmendmentCoverPremiumType,
      isOverridden: cover?.amendmentPPCVariance_isOverriden,
      Currency: currencySymbol,
    };
  });

  return {
    pagedItems,
    totalCount: covers.length,
    pageNumber: 1,
    pageSize: 10,
  };
}
